// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"f2af63d6","15":"d76a6f7c"}[chunkId] + ".chunk.js";
};